import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import PanesHeader from 'modules/core/components/PanesHeader'
import WithMultiSelectState from 'modules/core/components/WithMultiSelectState'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Importer from 'modules/employees/components/Importer'
import { useEmployeesImporter } from 'modules/employees/lib/employeesImporterContext'
// TODO: using private component from another page
import 'modules/employees/pages/ImportEmployeesPage/components/ImportTable/Content'

const Content = () => {
  const importer = useEmployeesImporter()

  return (
    <WithMultiSelectState items={importer.employees} initialSelection={importer.readyEmployees}>
      {() => (
        <Box>
          <PanesHeader
            illustration="multiple-actions-upload"
            title={i18n.t('import.table.title')}
            description={i18n.t('import.table.description')}
            separation={false}
          />
          <Box>
            <Importer importer={importer} />
          </Box>
        </Box>
      )}
    </WithMultiSelectState>
  )
}

const CustomTablesImportPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const importer = useEmployeesImporter()

  React.useEffect(() => {
    if (!importer.employees.length) {
      navigate(navigation.employees.fullPath())
    }
  }, [importer.employees, navigate])

  if (!importer.employees.length) return null

  return (
    <AuthorizeUser>
      <Content />
    </AuthorizeUser>
  )
}

export default observer(CustomTablesImportPage)
